"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Configuration = void 0;
const resources_1 = require("@opentelemetry/resources");
const semantic_conventions_1 = require("@opentelemetry/semantic-conventions");
class Configuration {
    // Constructor is protected and not private,
    // so it can be extended by ConfigurationNode
    constructor(config) {
        this._isSdkStarted = false;
        this.resource = (0, resources_1.defaultResource)().merge((0, resources_1.resourceFromAttributes)({
            [semantic_conventions_1.ATTR_SERVICE_NAME]: config.serviceName,
            [semantic_conventions_1.ATTR_SERVICE_VERSION]: config.serviceVersion,
        }));
        this.serviceName = config.serviceName;
        this.serviceVersion = config.serviceVersion;
        this.traceExporter = config.traceExporter || undefined;
        this.metricReader = config.metricReader;
        this.logRecordProcessor = config.logRecordProcessor;
        this.instrumentations = config.instrumentations;
        this.contextManager = config.contextManager;
        this.spanProcessors = config.spanProcessors || undefined;
        Configuration._instance = this;
    }
    static get instance() {
        return Configuration._instance;
    }
    static setConfiguration(config) {
        return new Configuration(config);
    }
    static start() {
        if (Configuration._instance) {
            Configuration._instance._isSdkStarted = true;
            return;
        }
        throw new Error('Configuration is not set before starting the SDK.');
    }
    static get isSdkStarted() {
        if (!Configuration._instance) {
            return false;
        }
        return Configuration._instance._isSdkStarted;
    }
}
exports.Configuration = Configuration;
//# sourceMappingURL=configuration.js.map